import { render } from "./SidebarMenuSub.vue?vue&type=template&id=75352be4&ts=true"
import script from "./SidebarMenuSub.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuSub.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuSub.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75352be4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75352be4', __exports__)) {
    api.reload('75352be4', __exports__)
  }
  
  module.hot.accept("./SidebarMenuSub.vue?vue&type=template&id=75352be4&ts=true", () => {
    api.rerender('75352be4', render)
  })

}


export default __exports__